<template>
    <div id="msisdnRechargeHistory">

        <!-- DETALLES BUTTON -->
        <div class="link-like text-right" @click="show = true"> 
            Historiales
            {{msisdn | msisdnToPhone}}
        </div>

        <!-- MODAL CONTAINER -->
        <ui-modal v-model="show">

            <!-- MODAL HEADER -->
            <div slot="header">
                Historiales
                <strong>{{msisdn | msisdnToPhone}}</strong>
            </div>

            <div class="fix-padding">

                <!-- TABS SELECTOR -->
                <tabbifier-header id="tabsSelector" v-model="selectedTab" :config="tabsOpt" />

                <!-- SELECTED TAB - RECARGAS -->
                <template v-if="selectedTab == recargasLabel">
                    <div class="centered-v" v-if="!chargeHistory.length">
                        Cargando... <i class="fa fa-refresh fa-spin"></i>
                    </div>
                    <div class="row padding-small item" v-for="charge in chargeHistory" :key="charge.id">
                        <div class="col centered-v">
                            <strong>{{charge.planName}}</strong> <br>
                            <small>{{charge.created | humanizar_fecha_hora}}</small>
                        </div>
                        <div class="col-tight centered-v">
                            <strong>
                                {{charge.recarga | currency }}
                            </strong>
                        </div>
                    </div>
                </template>

                <!-- SELECTED TAB - HISTORIAL DE LLAMADAS -->
                <template v-if="selectedTab == llamadasLabel">
                    <div class="centered-v" v-if="!callsHistory.length">
                        Cargando... <i class="fa fa-refresh fa-spin"></i>
                    </div>
                    <div class="row padding-small item row-centered-v" v-for="callItem in callsHistory" :key="callItem.id">
                        <div class="col-tight">
                            <strong>{{callItem.msisdnTarget | msisdnToPhone}}</strong>
                        </div>
                        <div class="col text-right">
                            <small>{{callItem.created}}</small> <br>
                            <small>( <i class="fa fa-clock"></i> {{duracionLlamada(callItem.callStart, callItem.callEnd)}})</small>
                        </div>
                    </div>
                </template>

            </div>

        </ui-modal>

    </div>
</template>

<script>
import tabbifierHeader from './tabbifier-header.vue'
import {msisdnToPhone} from './tools/filters'
import {duracionLlamada} from './tools/skycel.js'
import UiModal from './ui-modal.vue'

let recargasLabel = 'Recargas', llamadasLabel = 'Llamadas'
let tabsOpt = [recargasLabel, llamadasLabel]
let selectedTab = tabsOpt[0]

export default {
	components: { tabbifierHeader, UiModal},
    name: 'msisdnRechargeHistory',
    props: {
        msisdn: {
            type: [String, Number],
            required: true
        },
        chargeHistory: {
            type: Array,
            default: []
        },
        callsHistory: {
            type: Array,
            default: []
        }
    },
    data: () => {
        return {
            show: false,
            selectedTab, 
            tabsOpt,
            msisdnToPhone, recargasLabel, llamadasLabel
        }
    },
    methods: {
        duracionLlamada
    }
}
</script>

<style lang="less" scoped>
    .link-like {
        text-decoration: underline;
        &, STRONG {
            color: #b9bfc0;
            font-weight: bold;
        }
    }
    .col-tight {
        padding: 1em;
    }
    .centered-v {
        justify-content: center;
        display: flex;
        flex-flow: column;
    }
    .fix-padding {
        padding: 15px;
        padding-top: 0px;
    }
    .item:not(:last-child) {
        border-bottom: var(--ui-border);
    }
</style>